// extracted by mini-css-extract-plugin
module.exports = {"container":"data-bup-panel_container__1PdDC","container_title":"data-bup-panel_container_title__YDiKe"};